export const FormStateEnum = {
    start: 'start',
    success: 'success',
    error: 'error',
};
